import { StyledScreenReaderSpan } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledIcon, StyledPlainIconButton } from './styled-plain-icon-button';

const { forwardRef, useCallback } = React;

const sizes = ['large', 'medium', 'small'];

const propTypes = {
	icon: PropTypes.element.isRequired,
	ariaLabel: PropTypes.string,
	callback: PropTypes.func,
	className: PropTypes.string,
	color: PropTypes.string,
	dataTestId: PropTypes.string,
	disabled: PropTypes.bool,
	height: PropTypes.string,
	width: PropTypes.string,
	srLabel: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(sizes),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(sizes) }),
				{},
			),
		),
	]),
};
const defaultProps = {
	ariaLabel: undefined,
	callback: () => {},
	className: '',
	color: 'var(--color-global-black)',
	dataTestId: null,
	disabled: undefined,
	height: undefined,
	srLabel: undefined,
	size: 'small',
	width: undefined,
};

const PlainIconButton = forwardRef((props, ref) => {
	const {
		ariaLabel,
		callback,
		className,
		color,
		dataTestId,
		disabled,
		height,
		icon,
		srLabel,
		size,
		width,
		...other
	} = props;

	const clickHandler = useCallback((event) => {
		callback(event, ref);
	}, [callback, ref]);

	return (
		<StyledPlainIconButton
			aria-label={ariaLabel}
			className={className}
			data-testid={dataTestId}
			disabled={disabled}
			onClick={clickHandler}
			ref={ref}
			{...other}
		>
			<StyledIcon
				color={color}
				height={height}
				icon={icon}
				width={width}
				responsiveSize={size}
			/>
			<StyledScreenReaderSpan>{srLabel}</StyledScreenReaderSpan>
		</StyledPlainIconButton>
	);
});

PlainIconButton.propTypes = propTypes;
PlainIconButton.defaultProps = defaultProps;

export default PlainIconButton;
